module.exports = __webpack_public_path__ + "img/green_045.f8d9c6e8.png";